<template>
  <div>

    <div class="px-8 pt-4">
      <div class="text-center py-2">
        <Logo></Logo>
      </div>
    </div>

    <div v-if="!accepted">
      <div class="bg-radial py-0 md:py-0">
        <div class="md container mx-auto text-center p-8 md:max-w-md">
          <h1 class="text-white leading-normal text-center font-semibold">Please review the following before
            accepting</h1>
        </div>
      </div>

      <div class="bg-grey-lighter py-2 h-auto flex items-center">
        <div class="container max-w-md mx-auto flex flex-col items-center">
          <div class="container px-6 pt-6">
            <div class="mb-2">
              <p class="text-navy leading-normal">By clicking Accept, you declare that you have read and accept the
                terms stated in:</p>
              <ol class="text-navy leading-normal">
                <li v-if="loanType === 'Auto'">
                  <a class="text-blue" :href="loanContractUrl" target="_blank">Auto Loan Terms and Conditions </a>
                </li>
                <li v-else>
                  <a class="text-blue" :href="loanContractUrl" target="_blank">Personal Loan Terms and Conditions </a>
                </li>
                <li><a class="text-blue"
                       href="https://content.societyone.com.au/policies/Credit+Guide.pdf"
                       target="_blank">Credit Guide</a>
                </li>
                <li><a class="text-blue"
                       href="https://quote.societyone.com.au/privacy-disclosure-statement/"
                       target="_blank">Privacy Disclosure Statement;</a> and
                </li>
                <li><a class="text-blue"
                       href="https://docs.societyone.com.au/ASSETS/Direct+Debit+Service+Agreement.pdf"
                       target="_blank">Direct Debit Terms & Conditions</a>
                </li>
              </ol>
            </div>
          </div>
          <button class="bg-green hover:opacity-75 text-white py-4 px-8 mt-6 mb-4 rounded w-32 text-lg"
                  @click="acceptApplication">
            Accept
          </button>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="bg-radial py-0 md:py-0">
        <div class="md container mx-auto text-center p-8 md:max-w-md">
          <h1 class="text-white leading-normal text-center font-semibold">Thanks for accepting the Conditional Loan
            Offer</h1>
        </div>
      </div>
      <div class="bg-grey-lighter py-2 h-auto flex items-center">
        <div class="container max-w-md mx-auto flex flex-col items-center">
          <div class="container px-6 pt-6">
            <div class="mb-2">
              <h4 class="text-navy text-center leading-tight mb-8">Your application is now with our underwriting team
                for assessment.</h4>
            </div>
          </div>
          <div v-if="(showBs === 'true')">
            <div class="mb-2">
              <h2 class="text-navy text-center leading-tight mb-8">Speed up your application by submitting your bank
                statements online!</h2>
              <div class="rounded border customBorderColor customBlueLightest flex flex-col items-center p-4 mt-4 mb-4">
                <a class="text-blue-light no-underline mb-2 mx-auto text-md" :href="generatedBankLink" target="_blank">{{
                    generatedBankLink
                  }}</a>
              </div>
              <p class="text-navy leading-normal">We require:</p>
              <ol class="text-navy leading-normal">
                <li>Your last 6 months of bank statements for your transaction account showing your income and
                  expenses
                </li>
                <li>Your credit card, car loan or personal loan statements for the debt you wish to pay off with your
                  SocietyOne loan (if applicable)
                </li>
              </ol>
              <p class="text-navy mt-4 mb-4 leading-normal">BankStatements.com.au is an Australian owned company
                supporting over 120 financial institutions. They retrieve your bank statements without storing your
                personal banking login details. The read-only service sends your statements directly to our credit team
                for review.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <CustomerFooter></CustomerFooter>
  </div>
</template>

<script>
import Logo from '@/assets/Logo';
import CustomerFooter from '@/components/CustomerFooter';

export default {
  name: 'AcceptedLoanOffer',
  metaInfo: {
    title: 'Accepted Conditional Loan Offer',
  },
  components: {Logo, CustomerFooter},
  data() {
    return {
      accepted: false,
    }
  },
  computed: {
    encryptedPayload() {
      return this.$route.params.token;
    },
    loanContractUrl() {
      return this.$route.query.loanContractUrl;
    },
    generatedBankLink() {
      return this.$route.query.generatedBankLink;
    },
    loanType() {
      return this.$route.query.loanType;
    },
    showBs() {
      return this.$route.query.showBs;
    },
  },
  methods: {
    async acceptApplication() {
      try {
        const data = await this.$http.post('broker/loan-offer-acceptance', {
          encryptedPayload: this.encryptedPayload,
          mobile: '', // should be collected from form input
          dob: '', // should be collected from form input
        });
        if (data) {
          this.accepted = true;
        }
      } catch (e) {
        this.$toasted.error(`Error: ${(e.body && e.body.error) || e.message || 'Loan has already been accepted or does not exist'}`)
      }
    },
  },
};
</script>

<style scoped>
.badge-position {
  top: -10px;
  left: 50%;
  transform: translateX(-50%);
}
</style>



// WEBPACK FOOTER //
// src/pages/AcceptedLoanOffer.vue